<template>
    <div class="p-3">
        <h3>RL 3.17 Rekapitulasi Kegiatan Pelayanan Farmasi RS - Pengadaan Obat</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Rekapitulasi Kegiatan Pelayanan Farmasi RS - Pengadaan Obat"
            :filter-configs="filterConfigs" :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'start_date',
                    label: 'Tanggal Awal',
                    field: 'start_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
                {
                    id: 'end_date',
                    label: 'Tanggal Akhir',
                    field: 'end_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-pelayanan/kegiatan-pengadaan-obat',
                layout: 'fitData',
                responsiveLayout: 'collapse',
                columns: [
                    {
                        title: "No.",
                        field: "no",
                        hozAlign: "right",

                    },
                    {
                        title: "Golongan Obat",
                        field: "golongan_obat",
                    },
                    {
                        title: "Jumlah Item Obat",
                        field: "jml_item_obat",
                        hozAlign: "right",
                    },
                    {
                        title: "Jumlah Item Obat Yang Tersedia Di Rumah Sakit",
                        field: "jml_item_obat_tersedia_dirs",
                        hozAlign: "right",
                    },
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
